
// Setup the validate library, but add a custom
// wrapper to throw errors as an exception.
var validateLibrary = require("validate.js");

window.validate = function (value, type, error) {
    var constraint = {
        presence: true,
    }
    switch (type.toLowerCase()) {
        case "integer":
            constraint.numericality = { onlyInteger: true };
    }
    var result = validateLibrary.single(
        value,
        constraint,
    );

    // validateLibrary.single returns undefined if no errors are found
    if (result) {
        throw new Error(`${error} (${value} ${result.join(';')})`);
    }
}

// Usage Examples:
// validate("hello", "integer", "someFunction requires the first parameter to be an integer");
// validate(1, "integer", "You wont see this error because this example would pass validation");